module.exports = __webpack_public_path__ + "static/img/hua15.a63cfec.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/hua15.png
// module id = KRUT
// module chunks = 22